
import { Component, Vue } from "vue-property-decorator";
import WizardCart from "@/views/_components/WizardCart.vue";
import { namespace } from "vuex-class";
import CheckoutPersonalInfo from "@/views/_components/CheckoutPersonalInfo.vue";
import { CartItem } from "@/types/cart-item";
import { Cart } from "@/types/Cart";
import Loader from "@/components/Loader.vue";
import ElementLoader from "@/components/ElementLoader.vue";
import ValidationMessage from "@/views/_components/ValidationMessage.vue";
import UserService from "@/services/UserService";
import CartService from "@/services/CartService";
import User from "@/models/User";
const { State } = namespace("Root");

@Component({
  components: {
    WizardCart,
    CheckoutPersonalInfo,
    Loader,
    ElementLoader,
    ValidationMessage,
  },
})
export default class WizardThree extends Vue {
  @State("cart") cart!: Cart;
  @State("user") user!: User;

  contunueHTML = "&nbsp;";
  validated_list: any[] = [];
  validated = false;
  timeout: any;
  loading = false;
  button_loading = false;
  submitted = false;
  err_status = -1;
  err_message = "Please fill in required fields.";

  constructor() {
    super();
  }

  scrollToTop() {
    window.scrollTo(0, 0);
  }

  async created() {
    this.configureValidation();
  }

  async mounted() {
    this.cart.clearIfCompleted();
    this.scrollToTop();
    if (this.cart.items.length == 0) {
      this.$router.push({ name: "home" });
    }
    this.checkIfValidated();

    if (this.$route.query.redirectMsg !== undefined) {
      this.submitted = true;
    }

    if (!UserService.isLoggedInQuick()) {
      this.$router.push({ name: "wizard.two" });
    }
  }

  configureValidation() {
    this.cart.items.forEach((item) => {
      let data = {
        id: item.id,
        validated: false,
      };
      this.validated_list.push(data);
    });

    // Remove the validation object if the item is deleted.
    this.cart.itemRemoved.on(this.itemRemoved);
  }

  itemRemoved(cart_item?) {
    if (!cart_item) {
      return;
    }
    let index = this.validated_list.findIndex((item) => {
      return item.id == cart_item.id;
    });

    if (index >= 0) {
      this.validated_list.splice(index, 1);
      this.checkIfValidated();
    }

    // If we don't have items, go home.
    if (this.cart.items.length == 0) {
      this.timeout = setTimeout(this.goHome, 5000);
    }
  }

  beforeDestroy() {
    this.cart.itemRemoved.off(this.itemRemoved);
  }

  goHome() {
    clearTimeout(this.timeout);
    this.$router.push({ name: "home" });
  }

  removeFormErrors(target: string) {}

  async onSubmit() {
    this.submitted = true;
    if (!this.checkSerialNumberDuplicates()) {
      return;
    }
    if (this.validated) {
      // eslint-disable-next-line no-console
      console.log(this.validated);
      this.button_loading = true;
      let master = this.cart.items[0] as CartItem;
      // Loop all items that should match with the first of their type,
      // and fill the info.
      this.cart.items.forEach((item) => {
        if (!item.customer.different_user) {
          item.customer.first_name = master.customer.first_name;
          item.customer.last_name = master.customer.last_name;
        }
      });
      let utm_source = "";
      let utm_medium = "";
      let utm_campaign = "";
      let utm_content = "";
      if (this.cart?.utm_source) {
        //CHECK UTC source always should be one word
        if (!Array.isArray(this.cart.utm_source)) {
          utm_source = this.cart.utm_source;
        }
      }
      if (this.cart?.utm_medium) {
        //CHECK UTC source always should be one word
        if (!Array.isArray(this.cart.utm_medium)) {
          utm_medium = this.cart.utm_medium;
        }
      }
      if (this.cart?.utm_campaign) {
        //CHECK UTC source always should be one word
        if (!Array.isArray(this.cart.utm_campaign)) {
          utm_campaign = this.cart.utm_campaign;
        }
      }
      if (this.cart?.utm_content) {
        //CHECK UTC source always should be one word
        if (!Array.isArray(this.cart.utm_content)) {
          utm_content = this.cart.utm_content;
        }
      }
      let quoteIdFromAddingItemstoRemote = await CartService.addCartToRemote(
        this.cart
      );
      if (this.cart.quoteId < 0 || !this.cart.saved) {
        const quoteId = await CartService.saveQuote(
          this.cart,
          this.user.id,
          utm_source,
          utm_medium,
          utm_campaign,
          utm_content,
          quoteIdFromAddingItemstoRemote
        );
        if (quoteId > 0) {
          this.cart.saved = true;
          this.cart.quoteId = quoteId;
          this.$gtag.event("get_quote_count", {
            count: 1,
            quoteId: quoteId,
          });
        }
      }
      this.cart.persist();
      this.button_loading = false;
      this.$router.push({ name: "wizard.four" });
    } else {
      this.scrollToTop();
    }
  }

  checkSerialNumberDuplicates() {
    const serialNumbers = new Set();
    for (const item of this.cart.items) {
      if (serialNumbers.has(item.serial_number)) {
        alert(`Duplicate serial numbers detected in cart`);
        return false;
      }
      serialNumbers.add(item.serial_number);
    }
    return true;
  }

  infoValidated(id: any, validated: boolean) {
    let item = this.validated_list.find((item) => {
      return item.id == id;
    });
    if (item) {
      item.validated = validated;
      this.checkIfValidated();
    }
  }

  resetMessage() {
    this.err_status = -1;
    this.err_message = "";
  }

  checkIfValidated() {
    this.validated = this.validated_list.every((item) => {
      return item.validated == true;
    });
    if (!this.validated) {
      this.err_status = 2;
    }
  }
}
